import {connect} from 'react-redux';
import { createStructuredSelector } from 'reselect';
import Component from './Charts.Component';
import {getSlides} from "../../redux/reducers/slides";
import {
    getElectricityAvg,
    getTraveRelatedEmissionAvg,
    getWasteAvg,
    getWaterAvg
} from "../../redux/reducers/consumptionResource";


const mapStateToProps = createStructuredSelector<any,any>({
    slides: getSlides,
    electricityAvg: getElectricityAvg,
    waterAvg: getWaterAvg,
    wasteAvg: getWasteAvg,
    treAvg: getTraveRelatedEmissionAvg,
});

const mapDispatchToProps = {
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Component);